module.exports = __webpack_public_path__ + "static/media/Timer_WAITING@3x.278be25d.png";